import { of } from "rxjs";
import { filter, map, retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { actionCoopInfoInviteInfoReceived, TypeActionCoopInfo } from "../actionCoop";
export var epicCoopInviteInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionPlayerInfo.Received ||
            action.type === TypeActionCoopInfo.InviteInfoUpdate;
    }), switchMap(function () {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        return deps
            .netSend({
            id: CommandCode.PlayerInviteInfo,
            props: {
                playerId: playerId,
            },
        })
            .pipe(retry(), switchMap(function (playerInviteInfoResponse) {
            if (!playerInviteInfoResponse ||
                !playerInviteInfoResponse.activeInvite ||
                !playerInviteInfoResponse.activeInvite[0] ||
                !playerInviteInfoResponse.activeInvite[0].coopId) {
                return of(actionCoopInfoInviteInfoReceived({
                    activeInvite: undefined,
                    invitingCoop: undefined,
                }));
            }
            var activeInvite = playerInviteInfoResponse.activeInvite[0];
            return deps
                .netSend({
                id: CommandCode.CoopInfo,
                props: {
                    coopId: activeInvite.coopId,
                    playerId: playerId,
                },
            })
                .pipe(retry(), map(function (coopInfoResponse) {
                return actionCoopInfoInviteInfoReceived({
                    activeInvite: activeInvite,
                    invitingCoop: coopInfoResponse.coop,
                });
            }));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopInviteInfo.ts
// module id = 1806
// module chunks = 3